import { Tooltip as MuiTooltip } from '@mui/material';
import React from 'react';
import { ix } from '../../../utils/ix';
import { Typography } from '../../electrons';
import { DEFAULT_POSITION } from './Tooltip.constants';
import { useStyles } from './Tooltip.styles';
export function Tooltip({ id, className, popperClassName, placement, title, children, open, role }) {
    const classes = useStyles();
    const tooltipContent = React.createElement(Typography, { variant: "body2" }, title);
    return (React.createElement(MuiTooltip, { id: ix(id, 'tooltip'), className: className, title: tooltipContent, classes: {
            tooltip: classes.tooltip,
            arrow: classes.arrow,
            popper: popperClassName,
        }, placement: placement || DEFAULT_POSITION, open: open, role: role, arrow: true }, children));
}
//# sourceMappingURL=Tooltip.js.map